<nz-collapse nzGhost>
  <nz-collapse-panel
    nzCollapsible="icon"
    [nzHeader]="'general.note' | translate"
    [nzActive]="active"
    [nzCollapsible]="disabled ? 'disabled' : undefined"
  >
    @if (hasMixedValues.notes) {
      <div class="notes-info">
        {{
          containsTrainingsFromDigitalProvider
            ? ('page.training_qualifications.bulk_edit.modal.notes.info.mixed.containing_digital'
              | translate)
            : ('page.training_qualifications.bulk_edit.modal.notes.info.mixed'
              | translate)
        }}
      </div>
    }

    <nz-form-item>
      <nz-form-control>
        <nz-textarea-count [nzMaxCharacterCount]="420">
          <textarea
            rows="4"
            nz-input
            [formControl]="notesFormControl"
            [placeholder]="
              hasMixedValues.notes
                ? ('general.mixed' | translate)
                : ('general.write_a_note' | translate)
            "
          ></textarea>
        </nz-textarea-count>
      </nz-form-control>
    </nz-form-item>
  </nz-collapse-panel>
</nz-collapse>
